import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const categorySchema = z.object({
  id: z.number(),
  org: z.number(),
  category_path: z.string().nullable(),
  category_path_channel_id: z.string().nullable(),
  channel: z.string(),
  leaf_category_channel_id: z.number().nullable(),
  leaf_category_name: z.string(),
  market_place: z.string(),
  ad_count: z.number(),
  product_count: z.number(),
  search_rank: z.number(),
});
export type Category = z.infer<typeof categorySchema>;

export const gvadsApiDefinitions = prefixApi(
  "/gvads",
  apiBuilder({
    alias: "getCategories",
    method: "get",
    path: "/categories",
    parameters: [
      {
        name: "marketplace",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "channel",
        type: "Query",
        schema: z.string(),
      },
    ],
    status: 200,
    response: categorySchema.passthrough().array(),
  }).build(),
);

const reportStatusSchema = z.object({
  status: z.union([z.string(), z.number()]),
});

const reportStartSchema = z.object({
  query_type: z.string(),
  subscription_id: z.number().optional(),
  parameters: z
    .record(z.union([z.string(), z.number(), z.array(z.union([z.string(), z.number()]))]))
    .optional()
    .default({}),
  marketplace: z.string().optional().default("USA"),
});

const reportStartResponseSchema = z.object({
  detail: z.string(),
  report: z.any(),
});

export const amcApiDefinitions = prefixApi(
  "/amc",
  apiBuilder({
    alias: "getReportStatus",
    method: "get",
    path: "/reports/status/",
    parameters: [
      { name: "subscription_id", type: "Query", schema: z.number() },
      { name: "marketplace", type: "Query", schema: z.string() },
    ],
    status: 200,
    response: reportStatusSchema,
  })
    .addEndpoint({
      alias: "startReport",
      method: "post",
      path: "/reports/start/",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: reportStartSchema,
        },
      ],
      status: 200,
      response: reportStartResponseSchema,
    })
    .build(),
);
